import "react-app-polyfill/ie9";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Main from "./Main";
import "./helpers/initFA";
import "./style.css";
import CacheBuster from 'react-cache-buster';
import packageFile from "../package.json";
import Loader from "./components/common/Loader";
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

if (module.hot) {
  module.hot.accept();
}

// const loader = document.querySelector(".fullbody-loader");

// const hideLoader = () => {
//   loader.style.display = "none";
//   loader.style.height = "100%";
//   document.getElementsByClassName("fullbody")[0].style["height"] = "100%";
//   document.getElementsByClassName("fullbody-progress")[0].style["height"] = "0%";

// };

// Select all iframe elements
const iframes = document.querySelectorAll('iframe');

// Loop through each iframe



const loader = document.querySelector(".fullbody-loader");

const hideLoader = () => {
  if (loader) {
    loader.style.display = "none";
  }

  const fullbody = document.querySelector(".fullbody");
  const fullbodyProgress = document.querySelector(".fullbody-progress");

  if (fullbody) {
    fullbody.style.height = "100%";
  }

  if (fullbodyProgress) {
    fullbodyProgress.style.height = "0px";
  }
};

// Sentry.init({
//   dsn: "https://e48b39fce674425c9ddc7fc12694b2e1@o4504838234767360.ingest.sentry.io/4504838252986368",
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
// });
const isProduction = process.env.NODE_ENV === 'production';
const { version } = packageFile;

ReactDOM.render(
  <Main>
    <CacheBuster
     currentVersion={version}
     isEnabled={isProduction} //If false, the library is disabled.
     isVerboseMode={false} //If true, the library writes verbose logs to console.
     loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
     metaFileDirectory={'.'}
     >
      <App hideLoader={hideLoader} />
    </CacheBuster>
  </Main>,
  document.getElementById("root")
);
